import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { ACCOUNT_BLOCKED_ROUTE } from './auth/auth.service';
import {
  ActiveCallConsole,
  FAKE_CALL_CONTROLS_ENABLED,
} from './call-center/active-call-console/active-call-console';
import { WorkspaceRoleService } from './shell/workspace-role.service';

@Component({
  imports: [RouterModule, ActiveCallConsole],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly router = inject(Router);
  private readonly roleService = inject(WorkspaceRoleService);

  protected readonly fakeCallControls = inject(FAKE_CALL_CONTROLS_ENABLED);

  private readonly currentPath = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => this.router.url.split('?')[0].split('#')[0]),
      startWith(this.router.url.split('?')[0].split('#')[0]),
    ),
    { initialValue: this.router.url.split('?')[0].split('#')[0] },
  );

  /** Intake Specialist only (CCWIS-183); hide over field / portal / blocked routes. */
  protected readonly showActiveCallConsole = computed(() => {
    const path = this.currentPath();
    return (
      this.roleService.canUseCallPanel() &&
      !path.startsWith('/field') &&
      !path.startsWith('/portal') &&
      path !== ACCOUNT_BLOCKED_ROUTE
    );
  });
}
